import { Form, Select } from 'antd';
import { useMemo } from 'react';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const KeywordFilterField = (props: {
  required?: boolean;
  filterType:
    | SCRAPER_REQ_FIELD_KEY.INCLUDE_KEYWORDS
    | SCRAPER_REQ_FIELD_KEY.EXCLUDE_KEYWORDS;
}) => {
  const { required = false, filterType } = props;
  const label = useMemo(() => {
    switch (filterType) {
      case SCRAPER_REQ_FIELD_KEY.INCLUDE_KEYWORDS:
        return 'Include keyword';
      case SCRAPER_REQ_FIELD_KEY.EXCLUDE_KEYWORDS:
        return 'Exclude keyword';
      default:
        throw new Error(`Invalid filter type: ${filterType}`);
    }
  }, [filterType]);
  return (
    <>
      <Form.Item name={filterType} hidden required={required}>
        <input />
      </Form.Item>
      <Form.Item
        label={label}
        required={required}
        rules={
          required ? [{ required: true, message: `${label} is required` }] : []
        }
        shouldUpdate
      >
        {({ getFieldValue, setFieldValue }) => {
          const currentKeywords: string[] = getFieldValue(filterType) || [];
          return (
            <div className="flex-1 flex flex-col gap-3">
              <Select
                placeholder="Type keywords"
                style={{ flex: 1 }}
                value={currentKeywords}
                options={currentKeywords.map((keyword) => ({
                  label: keyword,
                  value: keyword,
                }))}
                onChange={(v) => {
                  setFieldValue(filterType, v);
                }}
                mode="tags"
                onSelect={(value) => {
                  if (!currentKeywords.includes(value)) {
                    setFieldValue(filterType, [...currentKeywords, value]);
                  }
                }}
              />
            </div>
          );
        }}
      </Form.Item>
    </>
  );
};
